import { ACCESS_TOKEN_KEY } from '../config';

export const accessTokenApi = {
  get: () => window.localStorage.getItem(ACCESS_TOKEN_KEY),
  set: (token: string) => window.localStorage.setItem(ACCESS_TOKEN_KEY, token),
  remove: () => window.localStorage.removeItem(ACCESS_TOKEN_KEY),
};
